/**
 * Tipos da API de Bases de Referência (M3) — docs/api-contracts.md → M3. Todas as
 * rotas respondem no envelope `{ data }` (revisão de 29/09/2026, C-M3).
 */

/** Tipo de base exposto pela API (maiúsculo). */
export type TipoBaseApi = 'INEP' | 'IBGE' | 'DDD';

/** Tipos que aceitam upload de nova versão (DDD é seed, sem rota). */
export type TipoBaseUpload = 'inep' | 'ibge';

/** Item de GET /bases. */
export interface BaseVersaoItem {
  readonly tipo: TipoBaseApi;
  readonly versao: string;
  readonly atualizadaEm: string;
  readonly registros: number;
}

/** Resposta de POST /bases/{tipo} (202). `cargaId` é o id do polling. */
export interface CargaBaseResponse {
  readonly cargaId: string;
  readonly tipo: TipoBaseApi;
  readonly versao: string;
  readonly status: 'processando';
}

/** Resposta de POST /bases/{tipo}/upload-url. */
export interface UploadUrlBase {
  readonly uploadUrl: string;
  readonly arquivoS3Key: string;
  readonly expiraEmSegundos: number;
}

/** Status de uma carga de base (GET /bases/cargas/{id}). */
export const STATUS_CARGA_BASE = ['processando', 'concluida', 'erro'] as const;
export type StatusCargaBase = (typeof STATUS_CARGA_BASE)[number];

/** Resposta de GET /bases/cargas/{id}. */
export interface EstadoCargaBase {
  readonly cargaId: string;
  readonly tipo: TipoBaseApi;
  readonly versao: string;
  readonly status: StatusCargaBase;
}

/** Content-Type de cada tipo de base (contrato de POST /bases/{tipo}/upload-url). */
export const CONTENT_TYPE_BASE: Readonly<Record<TipoBaseUpload, string>> = {
  inep: 'text/csv',
  ibge: 'application/geo+json',
};

/** Parâmetros de validação (GET/PATCH /parametros). */
export interface Parametros {
  readonly distanciaMaxKm: number;
  readonly confiancaMinima: number;
  readonly faixaAmpliadaMpLimite: number;
  /** Escola pelo nome no município (ADR-034): semelhança mínima do "candidato forte" (0 a 1). */
  readonly escolaNomeSimilaridadeMin: number;
  /** Folga mínima do 1º sobre o 2º candidato (0 a 1). */
  readonly escolaNomeFolgaMin: number;
  /** Período da campanha (ADR-035): início e fim em AAAAMMDD (ex.: 20130101). */
  readonly campanhaInicio: number;
  readonly campanhaFim: number;
  /** Ano assumido quando a data do termo não tem ano (ADR-035). */
  readonly campanhaAnoPadrao: number;
  /** Município pelo nome sem UF (ADR-035): nota mínima e folga sobre o 2º (0 a 1). */
  readonly municipioNomeSimilaridadeMin: number;
  readonly municipioNomeFolgaMin: number;
  /** Reprocessamento (ADR-036): acima desse custo estimado (US$), "Ler a imagem de novo" pede a segunda confirmação. */
  readonly confirmarReprocessamentoAcimaUsd: number;
}

/** Entrada do PATCH /parametros — todos opcionais. */
export interface PatchParametros {
  readonly distanciaMaxKm?: number;
  readonly confiancaMinima?: number;
  readonly faixaAmpliadaMpLimite?: number;
  readonly escolaNomeSimilaridadeMin?: number;
  readonly escolaNomeFolgaMin?: number;
  readonly campanhaInicio?: number;
  readonly campanhaFim?: number;
  readonly campanhaAnoPadrao?: number;
  readonly municipioNomeSimilaridadeMin?: number;
  readonly municipioNomeFolgaMin?: number;
  readonly confirmarReprocessamentoAcimaUsd?: number;
}
